module.exports = {
  'STATE_TOKEN_KEY_NAME': 'oktaStateToken',
  'DEFAULT_POLLING_DELAY': 500,
  'DEFAULT_MAX_CLOCK_SKEW': 300,
  'DEFAULT_CACHE_DURATION': 86400,
  'REDIRECT_OAUTH_PARAMS_COOKIE_NAME': 'okta-oauth-redirect-params',
  'REDIRECT_STATE_COOKIE_NAME': 'okta-oauth-state',
  'REDIRECT_NONCE_COOKIE_NAME': 'okta-oauth-nonce',
  'TOKEN_STORAGE_NAME': 'okta-token-storage',
  'CACHE_STORAGE_NAME': 'okta-cache-storage',
  'PKCE_STORAGE_NAME': 'okta-pkce-storage',
  'ACCESS_TOKEN_STORAGE_KEY': 'accessToken',
  'ID_TOKEN_STORAGE_KEY': 'idToken'
};


// WEBPACK FOOTER //
// ./lib/constants.js


// WEBPACK FOOTER //
// webpack:///lib/constants.js